// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LiveTV.css */

.app-container {
    display: flex;
    height: calc(100vh - 60px); /* ড্যাশবোর্ডের হেডার থাকলে সেটি বাদ দিয়ে */
    background-color: #0f0f0f;
    color: #fff;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    overflow: hidden;
}

/* Left Section: Video Player */
.left-section {
    flex: 3 1;
    display: flex;
    flex-direction: column;
    background: #000;
    padding: 20px;
}

.main-video-container {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.5);
}

.video-player {
    width: 100%;
    height: 100%;
    max-height: 80vh;
    outline: none;
}

/* Channel Info Below Player */
.channel-detail-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
    background: #1a1a1a;
    margin-top: 10px;
    border-radius: 8px;
}

.playing-now {
    display: flex;
    align-items: center;
    gap: 15px;
}

.mini-logo {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    object-fit: contain;
    background: #fff;
    padding: 5px;
}

.playing-now h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #ef4444; /* N-Tools theme Red/Orange accent */
}

.playing-now p {
    margin: 0;
    font-size: 0.85rem;
    color: #aaa;
}

/* Right Sidebar: Categories & Channels */
.right-sidebar {
    flex: 1 1;
    background: #121212;
    border-left: 1px solid #333;
    display: flex;
    flex-direction: column;
}

.sidebar-content {
    padding: 20px;
    overflow-y: auto;
}

.section-title {
    font-size: 1.1rem;
    margin-bottom: 15px;
    color: #eee;
    border-left: 4px solid #ef4444;
    padding-left: 10px;
}

.mt-30 { margin-top: 30px; }

/* Category Buttons */
.category-grid-layout {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.cat-btn {
    background: #222;
    border: 1px solid #333;
    color: #ccc;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.3s;
}

.cat-btn:hover {
    background: #333;
}

.cat-btn.active {
    background: #ef4444;
    color: #fff;
    border-color: #ef4444;
}

/* Channel List in Sidebar */
.sidebar-channel-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.side-grid-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px;
    background: #1a1a1a;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.2s;
    border: 1px solid transparent;
}

.side-grid-item:hover {
    background: #252525;
}

.side-grid-item.playing {
    border-color: #ef4444;
    background: rgba(239, 68, 68, 0.1);
}

.side-grid-item img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    object-fit: contain;
    background: #fff;
}

.side-name {
    font-size: 0.95rem;
    font-weight: 500;
}

/* Action Buttons */
.action-btns {
    display: flex;
    gap: 10px;
}

.btn-icon {
    background: #333;
    border: none;
    color: white;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
}

.btn-icon:hover {
    background: #ef4444;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .app-container {
        flex-direction: column;
        height: auto;
    }
    .right-sidebar {
        border-left: none;
        border-top: 1px solid #333;
    }
    .video-player {
        height: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/LiveTV/LiveTV.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,aAAa;IACb,0BAA0B,EAAE,2CAA2C;IACvE,yBAAyB;IACzB,WAAW;IACX,4DAA4D;IAC5D,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc,EAAE,oCAAoC;AACxD;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA,yCAAyC;AACzC;IACI,SAAO;IACP,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,SAAS,gBAAgB,EAAE;;AAE3B,qBAAqB;AACrB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* LiveTV.css */\n\n.app-container {\n    display: flex;\n    height: calc(100vh - 60px); /* ড্যাশবোর্ডের হেডার থাকলে সেটি বাদ দিয়ে */\n    background-color: #0f0f0f;\n    color: #fff;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    overflow: hidden;\n}\n\n/* Left Section: Video Player */\n.left-section {\n    flex: 3;\n    display: flex;\n    flex-direction: column;\n    background: #000;\n    padding: 20px;\n}\n\n.main-video-container {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.5);\n}\n\n.video-player {\n    width: 100%;\n    height: 100%;\n    max-height: 80vh;\n    outline: none;\n}\n\n/* Channel Info Below Player */\n.channel-detail-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 10px;\n    background: #1a1a1a;\n    margin-top: 10px;\n    border-radius: 8px;\n}\n\n.playing-now {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.mini-logo {\n    width: 50px;\n    height: 50px;\n    border-radius: 8px;\n    object-fit: contain;\n    background: #fff;\n    padding: 5px;\n}\n\n.playing-now h3 {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #ef4444; /* N-Tools theme Red/Orange accent */\n}\n\n.playing-now p {\n    margin: 0;\n    font-size: 0.85rem;\n    color: #aaa;\n}\n\n/* Right Sidebar: Categories & Channels */\n.right-sidebar {\n    flex: 1;\n    background: #121212;\n    border-left: 1px solid #333;\n    display: flex;\n    flex-direction: column;\n}\n\n.sidebar-content {\n    padding: 20px;\n    overflow-y: auto;\n}\n\n.section-title {\n    font-size: 1.1rem;\n    margin-bottom: 15px;\n    color: #eee;\n    border-left: 4px solid #ef4444;\n    padding-left: 10px;\n}\n\n.mt-30 { margin-top: 30px; }\n\n/* Category Buttons */\n.category-grid-layout {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n\n.cat-btn {\n    background: #222;\n    border: 1px solid #333;\n    color: #ccc;\n    padding: 8px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: 0.3s;\n}\n\n.cat-btn:hover {\n    background: #333;\n}\n\n.cat-btn.active {\n    background: #ef4444;\n    color: #fff;\n    border-color: #ef4444;\n}\n\n/* Channel List in Sidebar */\n.sidebar-channel-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.side-grid-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px;\n    background: #1a1a1a;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: 0.2s;\n    border: 1px solid transparent;\n}\n\n.side-grid-item:hover {\n    background: #252525;\n}\n\n.side-grid-item.playing {\n    border-color: #ef4444;\n    background: rgba(239, 68, 68, 0.1);\n}\n\n.side-grid-item img {\n    width: 40px;\n    height: 40px;\n    border-radius: 4px;\n    object-fit: contain;\n    background: #fff;\n}\n\n.side-name {\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n/* Action Buttons */\n.action-btns {\n    display: flex;\n    gap: 10px;\n}\n\n.btn-icon {\n    background: #333;\n    border: none;\n    color: white;\n    padding: 8px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: 0.3s;\n}\n\n.btn-icon:hover {\n    background: #ef4444;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n    .app-container {\n        flex-direction: column;\n        height: auto;\n    }\n    .right-sidebar {\n        border-left: none;\n        border-top: 1px solid #333;\n    }\n    .video-player {\n        height: 250px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
